import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { UpdateToken } from './state/configuration/config.actions';
import { AppContextService, EcaAppShellModule } from '@drc-eca/eca-components-lib';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { BuildInfo } from './app.build-info';
import { Observable } from 'rxjs';
import { SpinnerService } from '@drc-eca/eca-lrc-common-ui';
import { AsyncPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'eca-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [EcaAppShellModule, RouterOutlet, MatProgressSpinner, AsyncPipe]
})
export class AppComponent {
  private store = inject<Store<any>>(Store);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private appContextService = inject(AppContextService);
  private spinnerService = inject(SpinnerService);


  spinner$: Observable<boolean>;

  constructor() {

    this.store.dispatch(new UpdateToken());
    this.spinner$ = this.spinnerService.spinner.asObservable();
    console.log('Local Scanning UI build info:', JSON.stringify(BuildInfo.getBuildInfo()));

  }

}
